import "@zebra-fed/icons/Enterprise/index.css";
import styled from 'styled-components'
import {Dialog} from '@zebra-fed/zds-react-desktop'
import { Button } from '@material-ui/core';
import React, {useState, useEffect, useContext} from 'react'
import {Close} from '@material-ui/icons'
import {useTranslation} from 'react-i18next'
import {AvailableDeviceListTable} from './AvailableDeviceListTable'
import {DeviceCardsContainer} from './DeviceCardsContainer'
import {useDashboardContext} from '../context/dashboard.context'
import {useDashboardFiltersContext} from '../context/dashboard-filter.context'
import {DashboardFilters} from './dashboard-filters'
import {InUseDeviceListTable} from './InUseDeviceListTable'
import {MissingDeviceListTable} from './MissingDeviceListTable'
import firebaseUtil, { fetchDevicesCount } from '../../../data/FirebaseUtil'
import { userJustManager } from '../../../data/userUtil';
import { AuthContext } from '../../../authentication/Auth';
import { fetchDeviceList, getDeviceCount, fetchLastPage } from "./devicesQueries";
import { DEVICE_STATUS } from '../constant/Dashboard.constant';
import { Snackbar } from '@material-ui/core';
import { SnackbarContent } from '../../../styled-components/shared';

const ModalHeader = styled.div`
  display: flex;
  height: 60px;
  font-size: 18px;
  align-items: center;
  padding: 0 24px;
  justify-content: left;
  position: sticky;
  top: 0;
  background-color: white;
`

const ScrollableContent = styled.div`
  overflow-y: auto;
  padding: 24px;
`

const CardContainer = styled.div`
  padding: 0px 24px;
`

const DashboardFiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0px 24px 0px;
  align-items: center;
`

const DashboardFilterSection = styled.div`
  display: flex;
  justify-content: space-between;
`

export const DeviceSummaryPopupComponent = ({modalRef, onClose}) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const {selectedCard, isLoading, setIsLoading, setAvailableCount, setAvailableDeviceList, setInUseCount, setInUseDeviceList, setMissingCount, setMissingDeviceList, setAvailableDeviceCursor, setInUseDeviceCursor, setMissingDeviceCursor} = useDashboardContext()
  const {selectedCabinets, filterSelection, setIsResetFilter, setCurrentPage} =
    useDashboardFiltersContext()
  const context = useContext(AuthContext);
  const isManager = userJustManager(context.currentUser.claims);
  const {t} = useTranslation()

  useEffect(() => {
    if (selectedCabinets.length > 0) {
      getDashbordData();
    }
  }, [filterSelection])

  const closePopUp = () => {
    setIsResetFilter(new Date());
    onClose();
    setCurrentPage('dashboard');
  }

  const getDashbordData = async() => {
    const { available, inUse, missing} = await fetchDeviceCount() || { available: 0, inUse: 0, missing: 0 };
    const tenantName = context.currentUser.claims.companyID;
    const availableQuery = fetchDeviceData({ state: 'available', tenantName, totalCount: available });
    const missingQuery = fetchDeviceData({ state: 'missing', tenantName, totalCount: inUse });
    const inUseQuery = fetchDeviceData({ state: 'inUse', tenantName, totalCount: missing });
    const response = await Promise.all([availableQuery, missingQuery, inUseQuery]);
    console.log(response)
    setIsLoading(false);
    setAvailableDeviceList(response[0]?.devices || 0)
    setMissingDeviceList(response[1]?.devices || 0)
    setInUseDeviceList(response[2]?.devices || 0)
    setAvailableDeviceCursor(response[0]?.cursors || {})
    setMissingDeviceCursor(response[1]?.cursors || {})
    setInUseDeviceCursor(response[2]?.cursors || {})
  }

  const onCardSelection = (_state) => {}

  const fetchDeviceData = async(params) => {
    const { companyID } = context.currentUser.claims;
    const kiosks = selectedCabinets?.length
    ? selectedCabinets.map((e) => e.value)
    : !isManager
    ? ['select-all']
    : [];
    let deviceStates, checkOutState, isCharging;
    switch (params.state) {
      case "available":
        deviceStates = [DEVICE_STATUS.available];
        checkOutState = false;
        isCharging = true;
        break;
      case "missing":
        deviceStates = [DEVICE_STATUS.missing, DEVICE_STATUS.beingFound]
        checkOutState = false;
        isCharging = false;
        break;
      case "inUse":
        deviceStates = [DEVICE_STATUS.inUse]
        checkOutState = true;
        isCharging = false;
        break;
      default:
        deviceStates = [DEVICE_STATUS.available]
        break;
    }
    return await fetchDeviceList({ ...params, kiosks, companyID, deviceStates, checkOutState, isCharging, isDashboardPage: true });
  }

    const fetchDeviceCount = async () => {
      const kiosks = selectedCabinets?.length
      ? selectedCabinets.map((e) => e.value)
      : !isManager
      ? ['select-all']
      : [];
      const deviceCountResult = await fetchDevicesCount({tenantName:context.currentUser.claims.companyID, kiosks})
      .catch((error) => {
        console.error('Error fetching device count:', error);
        setIsLoading(false);
      });
      const deviceCount = deviceCountResult?.data
      setAvailableCount(deviceCount?.available || 0);
      setInUseCount(deviceCount?.inUse || 0);
      setMissingCount(deviceCount?.missing || 0);
      return deviceCount
    }

    const updateDeviceStatus = async(action, rowData) => {
        const status = action === 'lost' ? DEVICE_STATUS.lost : DEVICE_STATUS.rma; // Need to revisit after discussion with DT team
        const { serialNumber, statusReason, modelNumber } = rowData;
        const params = { deviceName: `${modelNumber}_${serialNumber}`, status, statusReason, lastStatusUpdate: new Date().getTime() };
        const res = await firebaseUtil.updateDeviceStatus(params).catch(err => {
          console.error('Error updating status:', err);
        });
        console.log('Status Updated ', res);
        setSnackbarOpen(true)
        getDashbordData();
    }

  return (
    <Dialog
      ref={modalRef}
      width="80vw"
      key='dialog_dashboard'
      headerStyle={{padding: '10px 20px', display: 'none'}}
      bodyStyle={{padding: '0px', width: '100%'}}
      cardStyle={{borderRadius: '8px', overflow: 'auto'}}
      style={{cursor: isLoading ? 'wait' : 'default', zIndex: 22}}
    >
      <DashboardFiltersContainer>
        <ModalHeader>{t('deviceSummary')}</ModalHeader>
        <DashboardFilterSection>
          <DashboardFilters />
            <Button onClick={closePopUp} variant="text">
              <Close />
            </Button>
        </DashboardFilterSection>
      </DashboardFiltersContainer>
      <CardContainer>
        <DeviceCardsContainer
          openDetailPopup={onCardSelection}
          pageName="popup"
        ></DeviceCardsContainer>
      </CardContainer>
      <ScrollableContent>
        {selectedCard === 'available' && (
          <AvailableDeviceListTable
            tableHeader={`${t(selectedCard)} Devices`}
            fetchData={fetchDeviceData}
          />
        )}
        {selectedCard === 'inUse' && (
          <InUseDeviceListTable
            tableHeader={`${t(selectedCard)} Devices`}
            fetchData={fetchDeviceData}
            updateDeviceStatus={updateDeviceStatus}
          />
        )}
        {selectedCard === 'missing' && (
          <MissingDeviceListTable
            tableHeader={`${t(selectedCard)} Devices`}
            fetchData={fetchDeviceData}
            updateDeviceStatus={updateDeviceStatus}
          />
        )}
      </ScrollableContent>
      <Snackbar 
        open={snackbarOpen} 
        autoHideDuration={3000} 
        onClose={() => setSnackbarOpen(false)}
    >
        <SnackbarContent error={false}>
            Updated successfully
        </SnackbarContent>
    </Snackbar>
    </Dialog>
  )
}
